import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe8817a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-container" }
const _hoisted_2 = { class: "dropdown-button" }

import { ref, computed } from 'vue';
import AdminPageLayout from "@/layouts/default/admin/AdminPageLayout.vue";
import TabByIP from '@/components/securite/whitelist/TabByIP.vue';
import TabByCompany from '@/components/securite/whitelist/TabByCompany.vue';
import TabByEmail from '@/components/securite/whitelist/TabByEmail.vue';
import WhiteListModal from '@/components/modal/whiteList/WhiteListModal.vue';
import ApiService from '@/_services/api.service';
import { useToast } from 'primevue/usetoast';
import Button from 'primevue/button';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import ConfirmDialog from 'primevue/confirmdialog';
import { useConfirm } from 'primevue/useconfirm';
import { CompanyWhitelist } from '@/models/securite/whitelist/IcompanyWhiteLis';


export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteList2fa',
  setup(__props) {

const toast = useToast();
const showDialog = ref(false);
const selectedMethod = ref<string>('IP');
const confirm = useConfirm();
const tableData = ref<CompanyWhitelist[]>([]);

const dialogHeader = computed(() => {
    const method = selectedMethod.value;
    let methodText = '';

    switch (method) {
        case 'IP':
            methodText = 'IP';
            break;
        case 'Company':
            methodText = 'Société';
            break;
        case 'Email':
            methodText = 'Email';
            break;
    }
    return `Ajouter par ${methodText}`;
});
const isSubmitting = ref(false);
const onAddConfirm = async (data: any) => {
    if (isSubmitting.value) return;
    isSubmitting.value = true;
    
    let endpoint = '';
    let postData = {};
    const error = ref<string>("");

    switch (selectedMethod.value) {
        case 'IP':
            endpoint = 'ip_white_lists';
            postData = {
                ipAddress: data.address,
                company: data.company,
                description: data.description,
                requestedBy: data.requestedBy
            };
            break;
        case 'Company':
            endpoint = 'company_white_lists';
            postData = {
                company: data.companyName,
                description: data.description,
                requestedBy: data.requestedBy
            };
            break;
        case 'Email':
            endpoint = 'user_white_lists';
            postData = {
                email: data.email,
                description: data.description,
                requestedBy: data.requestedBy
            };
            break;
    }
    isSubmitting.value = true;
    try {
        const response = await ApiService.post(endpoint, postData);
        showDialog.value = false;
        toast.add({ severity: 'success', summary: 'Succès', detail: 'Élément ajouté avec succès!', life: 3000 });
        window.location.reload();
    } catch (err: any) {
        error.value = `L'adresse mail fournie est invalide. Veuillez vérifier et réessayer.`;
        toast.add({ severity: 'error', summary: 'Erreur', detail: error.value, life: 3000 });    
    } finally {
        isSubmitting.value = false;
    }
};

const updateSelectedMethod = (newMethod: string) => {
    selectedMethod.value = newMethod;
};

const updateTableData = (newData: CompanyWhitelist[]) => {
    tableData.value = newData;
};

const confirmDeleteDialog = (data) => {
    confirm.require({
        group: 'global',
        message: `Êtes-vous sûr de vouloir supprimer cet élément ?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Oui",
        rejectLabel: "Non",
        acceptClass: 'my-custom-accept-class',
        accept: async () => {
            try {
                toast.add({ severity: 'success', summary: 'Supprimé', detail: 'Élément supprimé avec succès', life: 3000 });
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la suppression', life: 3000 });
            }
        }
    });
};
const confirmStatusChangeDialog = (data) => {
    confirm.require({
        group: 'global-status',
        message: `Êtes-vous sûr de vouloir changer le statut de cet élément ?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Oui",
        rejectLabel: "Non",
        accept: async () => {
            try {
                toast.add({ severity: 'success', summary: 'Succès', detail: `Le statut a bien été modifié`, life: 3000 });
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la modification', life: 3000 });
            }
        }
    });
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createBlock(AdminPageLayout, null, {
    titleName: _withCtx(() => [
      _createTextVNode(" WHITELIST DES UTILISATEURS POUR LA DOUBLE AUTHENTIFICATION ")
    ]),
    content: _withCtx(() => [
      _createVNode(_component_Toast),
      _createVNode(_unref(ConfirmDialog), {
        group: "global",
        closeOnEscape: false,
        closable: false
      }),
      _createVNode(_unref(ConfirmDialog), {
        group: "global-status",
        closeOnEscape: false,
        closable: false
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Button), {
            label: "Ajouter un utilisateur à la whitelist",
            icon: "pi pi-plus",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = true)),
            class: "custom-button button-add"
          })
        ])
      ]),
      _createVNode(_unref(TabView), null, {
        default: _withCtx(() => [
          _createVNode(_unref(TabPanel), { header: "Par IP" }, {
            default: _withCtx(() => [
              _createVNode(TabByIP, {
                onConfirmDelete: confirmDeleteDialog,
                onConfirmStatusChange: confirmStatusChangeDialog
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(TabPanel), { header: "Par société" }, {
            default: _withCtx(() => [
              _createVNode(TabByCompany, {
                onConfirmDelete: confirmDeleteDialog,
                onConfirmStatusChange: confirmStatusChangeDialog,
                onUpdateTableData: updateTableData
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(TabPanel), { header: "Par email" }, {
            default: _withCtx(() => [
              _createVNode(TabByEmail, {
                onConfirmDelete: confirmDeleteDialog,
                onConfirmStatusChange: confirmStatusChangeDialog
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(WhiteListModal, {
        visible: showDialog.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
        header: dialogHeader.value,
        "selected-method": selectedMethod.value,
        "table-data": tableData.value,
        "onUpdate:selectedMethod": updateSelectedMethod,
        onConfirm: onAddConfirm,
        "is-submitting": isSubmitting.value
      }, null, 8, ["visible", "header", "selected-method", "table-data", "is-submitting"])
    ]),
    _: 1
  }))
}
}

})